<template>
  <component-wrapper>
    <grid-container-fi
      :class="{
        'contact-fi': true,
        'contact-fi--dark': fields?.darkBackground?.value,
      }"
      grid-class="contact-fi__content"
    >
      <div
        class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-7 lg:fi-col-end-6 xl:fi-col-start-3 xl:fi-col-end-7"
      >
        <div class="contact-fi__headline">
          <headline-fi
            v-if="fields?.subheadline?.value || isEditMode || inlineEditMode"
            class="fi-mb-12"
            tag="div"
            color="brand"
            data-field="subheadline"
            field-name="subheadline"
            :size="30"
          />
          <headline-fi
            v-if="fields?.headline?.value || isEditMode || inlineEditMode"
            tag="h3"
            :size="60"
            field-name="headline"
          />
        </div>
      </div>
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-8 lg:fi-col-end-11">
        <div class="contact-fi__contact-details">
          <single-line-text-field-fi
            class="contact-fi__contact-details-head contact-fi__detail-line"
            field-name="contactDetailsHeadline"
          />
          <contact-details-fi />
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { HeadlineFi, SingleLineTextFieldFi } from 'atoms';
import { inject } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import ContactDetailsFi from '@/components/contact-details-fi/ContactDetailsFi.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useInlineEdit } from '@/composables/inlineEdit';
import type { CheckboxField, SingleLineTextField } from '@/sitecoreFieldTypes';

defineOptions({
  name: 'ContactFi',
});

const fields = inject<{
  darkBackground?: CheckboxField;
  subheadline?: SingleLineTextField;
  headline?: SingleLineTextField;
  contactDetailsHeadline?: SingleLineTextField;
}>('fields');

const { inlineEditMode } = useInlineEdit();
</script>

<style scoped src="./contact-fi" />

<style src="./contact-fi-unscoped" />
